(() => {
  if (window.__dlCartFlowSafeV6) return;
  window.__dlCartFlowSafeV6 = true;

  const HATS = {
    white: { id: '48460550013113', label: 'White Richardson 112', x: 49.5, y: 42.5 },
    black: { id: '48460549980345', label: 'Black Richardson 112', x: 49.5, y: 45.8 },
    canvas: { id: '49115317928121', label: 'Canvas Snapback', x: 49.95, y: 45.5 }
  };
  const PETS_B_HATS = { white: {...HATS.white,id:'67867553202361'}, black: {...HATS.black,id:'67867553169593'}, canvas: {...HATS.canvas,id:'67867553235129'} };
  const isPetsB = root => root.dataset.petsBonusOffer === 'true';
  const hatsFor = root => isPetsB(root) ? PETS_B_HATS : HATS;
  const requiredSaved = root => Array.from({length:isPetsB(root)?1:2},(_,i)=>i).every(i=>root.__dlSlots?.[i] && root.dataset[`dlSaved${i+1}`]==='1');
  const byId = Object.fromEntries(Object.entries({...HATS,...Object.fromEntries(Object.entries(PETS_B_HATS).map(([k,v])=>[k+'-pets-b',v]))}).map(([key, value]) => [value.id, key.replace('-pets-b','')]));

  function tell(root, message, target) {
    const notice = root.querySelector('[data-notice]');
    const results = root.querySelector('[data-results]');
    if (notice) {
      notice.textContent = message;
      notice.hidden = false;
    }
    if (results) results.hidden = false;
    if (target) setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'center' }), 30);
  }

  function prerequisiteNotice(root, consent) {
    root.querySelectorAll('[data-notice],[data-bundle-warning]').forEach(el => { el.hidden = true; });
    root.querySelectorAll('[data-dl-prerequisite-notice]').forEach(el => el.remove());
    const area = consent ? root.querySelector('[data-rights]')?.closest('.rights') : root.querySelector('.hatpicker');
    if (!area) return;
    const box = document.createElement('div');
    box.dataset.dlPrerequisiteNotice = consent ? 'consent' : 'drops';
    box.setAttribute('role', 'alert');
    box.style.cssText = 'display:block;width:100%;box-sizing:border-box;background:#fff3d5;color:#111;border-radius:16px;padding:16px;margin:12px 0;font-size:16px;line-height:1.45';
    box.textContent = consent ? 'Please confirm you have permission to use your uploaded image(s). ☝️' : (isPetsB(root) ? 'Please upload and save your pet emblem before adding your hat to cart. 👇' : 'Please create and save both Drop 1 and Drop 2 below before adding your bundle to cart. 👇');
    if (!consent) {
      box.style.order = '2';
      box.style.gridColumn = '1 / -1';
    }
    area.insertAdjacentElement(consent ? 'afterend' : 'beforebegin', box);
    const target = consent ? (root.querySelector('.buy .summary') || root.querySelector('.buy') || area) : (root.querySelector('.stageviewport') || root.querySelector('.stagewrap') || area);
    requestAnimationFrame(() => window.scrollTo({top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - (consent ? 84 : 20)), behavior:'instant'}));
  }

  function currentKey(root) {
    return HATS[root.dataset.hat] ? root.dataset.hat : 'white';
  }

  function syncHatChecks(root, key) {
    root.querySelectorAll('[data-hat-choice]').forEach(button => {
      const selected = button.dataset.hatChoice === key;
      button.classList.toggle('active', selected);
      button.classList.toggle('dl-guide-confirmed', selected);
    });
  }

  function applyHat(root, key, { updateSelect = true } = {}) {
    const meta = hatsFor(root)[key];
    if (!meta) return false;
    const button = root.querySelector(`[data-hat-choice="${key}"]`);
    const hat = root.querySelector('[data-hat-preview]');
    const select = root.querySelector('[data-variants]');
    root.dataset.hat = key;
    syncHatChecks(root, key);
    if (hat && button?.dataset.hatSrc) {
      hat.removeAttribute('srcset');
      hat.removeAttribute('sizes');
      hat.src = button.dataset.hatPreviewSrc || button.dataset.hatSrc;
      hat.alt = button.querySelector('img')?.alt || meta.label;
    }
    if (updateSelect && select && select.value !== meta.id && [...select.options].some(option => option.value === meta.id)) {
      select.value = meta.id;
    }
    root.dispatchEvent(new CustomEvent('droplit:hat-changed', {
      bubbles: true,
      detail: { key, id: meta.id, label: meta.label, src: button?.dataset.hatSrc || '' }
    }));
    return true;
  }

  function cleanDropName(drop, number) {
    const fallback = `Drop ${number}`;
    let name = String(drop?.title || drop?.originalTitle || fallback).trim();
    if (/^https?:\/\//i.test(name)) {
      try {
        name = decodeURIComponent(new URL(name).pathname.split('/').pop() || fallback);
      } catch (_) {
        name = fallback;
      }
    }
    name = name.replace(/\.(png|jpe?g|webp|heic|heif)$/i, '');
    name = name.replace(/-(optimized|cropped)$/i, '');
    name = name.replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
    return name || fallback;
  }

  function artworkValue(drop) {
    return drop?.production || drop?.preview || drop?.originalPreview || '';
  }

  function canvasBlob(canvas, compact) {
    return new Promise((resolve, reject) => {
      canvas.toBlob(blob => {
        if (blob) resolve(blob);
        else reject(new Error('Placement proof image could not be created.'));
      }, compact ? 'image/jpeg' : 'image/png', compact ? 0.9 : undefined);
    });
  }

  function loadImage(source) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      let ownedUrl = '';
      if (source instanceof Blob) {
        ownedUrl = URL.createObjectURL(source);
        image.src = ownedUrl;
      } else {
        image.crossOrigin = 'anonymous';
        image.src = String(source || '');
      }
      image.onload = () => resolve({ image, ownedUrl });
      image.onerror = () => {
        if (ownedUrl) URL.revokeObjectURL(ownedUrl);
        reject(new Error('A Drop image could not be loaded for its placement proof.'));
      };
    });
  }

  function drawContained(context, image, x, y, width, height) {
    const naturalWidth = image.naturalWidth || image.width;
    const naturalHeight = image.naturalHeight || image.height;
    const ratio = Math.min(width / naturalWidth, height / naturalHeight);
    const drawWidth = naturalWidth * ratio;
    const drawHeight = naturalHeight * ratio;
    context.drawImage(image, x + (width - drawWidth) / 2, y + (height - drawHeight) / 2, drawWidth, drawHeight);
  }

  async function makePlacementProof(root, drop, number) {
    const key = currentKey(root);
    const meta = hatsFor(root)[key];
    const hatButton = root.querySelector(`[data-hat-choice="${key}"]`);
    const hatSource = (root.hasAttribute('data-pet-builder') ? hatButton?.dataset.hatPreviewSrc : '') || hatButton?.dataset.hatSrc || root.querySelector('[data-hat-preview]')?.src;
    const artworkSource = drop?.mikeDesignId && drop?.preview
      ? drop.preview
      : drop?.printFile instanceof Blob
      ? drop.printFile
      : drop?.file instanceof Blob
        ? drop.file
        : artworkValue(drop);
    if (!hatSource || !artworkSource) throw new Error(`Drop ${number} is missing artwork for its placement proof.`);

    const [{ image: hatImage, ownedUrl: hatUrl }, { image: artworkImage, ownedUrl: artworkUrl }] = await Promise.all([
      loadImage(hatSource),
      loadImage(artworkSource)
    ]);

    try {
      const width = 900;
      const header = 64;
      const stageHeight = 675;
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = header + stageHeight;
      const context = canvas.getContext('2d', { alpha: false });
      if (!context) throw new Error('Placement proof canvas is unavailable.');

      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, width, canvas.height);
      context.fillStyle = '#111111';
      context.font = '700 22px -apple-system, BlinkMacSystemFont, Arial, sans-serif';
      context.fillText(`DROP ${number} — SAVED`, 28, 40);
      context.textAlign = 'right';
      context.font = '500 18px -apple-system, BlinkMacSystemFont, Arial, sans-serif';
      context.fillStyle = '#555555';
      context.fillText(meta.label.toUpperCase(), width - 28, 40);
      context.textAlign = 'left';

      const gradient = context.createRadialGradient(width / 2, header + stageHeight * 0.43, 10, width / 2, header + stageHeight * 0.5, width * 0.62);
      gradient.addColorStop(0, '#ffffff');
      gradient.addColorStop(0.45, '#f4f3f0');
      gradient.addColorStop(1, '#deddd9');
      context.fillStyle = gradient;
      context.fillRect(0, header, width, stageHeight);
      drawContained(context, hatImage, 0, header, width, stageHeight);

      const scale = Math.max(0.4, Math.min(2.5, Number(drop?.scale) || 1));
      const boxSize = width * 0.18 * scale;
      const centerX = width * ((meta.x + (Number(drop?.positionX) || 0)) / 100);
      const centerY = header + stageHeight * ((meta.y + (Number(drop?.positionY) || 0)) / 100);
      const radius = Math.max(0, Math.min(50, Number(drop?.cornerRadius) || 0)) / 100 * boxSize;

      context.save();
      if (radius > 0) {
        context.beginPath();
        context.roundRect(centerX - boxSize / 2, centerY - boxSize / 2, boxSize, boxSize, radius);
        context.clip();
      }
      drawContained(context, artworkImage, centerX - boxSize / 2, centerY - boxSize / 2, boxSize, boxSize);
      context.restore();

      const compact = root.hasAttribute('data-pet-builder');
      const blob = await canvasBlob(canvas, compact);
      return new File([blob], `droplit-drop-${number}-placement-proof.${compact ? 'jpg' : 'png'}`, { type: blob.type, lastModified: Date.now() });
    } finally {
      if (hatUrl) URL.revokeObjectURL(hatUrl);
      if (artworkUrl) URL.revokeObjectURL(artworkUrl);
    }
  }

  const artworkCache = new WeakMap();
  function compactArtwork(drop) {
    const original = drop?.printFile instanceof Blob ? drop.printFile : drop?.file instanceof Blob ? drop.file : null;
    if (!original || drop?.mikeDesignId || original.size < 512 * 1024 || !/^image\/(png|jpeg)$/.test(original.type)) return Promise.resolve(original);
    if (artworkCache.has(original)) return artworkCache.get(original);
    const pending = (async () => {
      let loaded, canvas;
      try {
        loaded = await loadImage(original);
        canvas = document.createElement('canvas');
        canvas.width = loaded.image.naturalWidth;
        canvas.height = loaded.image.naturalHeight;
        const context = canvas.getContext('2d');
        if (!context) return original;
        context.drawImage(loaded.image, 0, 0);
        const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/webp', 0.98));
        if (!blob || blob.type !== 'image/webp' || blob.size >= original.size * 0.9) return original;
        return new File([blob], (original.name || 'droplit-print').replace(/\.[^.]+$/, '') + '.webp', { type: 'image/webp', lastModified: original.lastModified || Date.now() });
      } catch (_) {
        return original;
      } finally {
        if (loaded?.ownedUrl) URL.revokeObjectURL(loaded.ownedUrl);
        if (canvas) canvas.width = canvas.height = 1;
      }
    })();
    artworkCache.set(original, pending);
    return pending;
  }

  const remoteAssets = new WeakMap();
  const assetQueue = [];
  let activeAssetUploads = 0;
  let assetBackoffUntil = 0;
  const assetOrigin = 'https://droplit-nfc.brian-1b8.workers.dev';
  function pumpAssetQueue() {
    while (activeAssetUploads < 2 && assetQueue.length) {
      const job = assetQueue.shift();
      activeAssetUploads++;
      job().finally(() => { activeAssetUploads--; pumpAssetQueue(); });
    }
  }
  function backgroundAsset(root, blob) {
    if (!(blob instanceof Blob) || blob.size > 12 * 1024 * 1024 || Date.now() < assetBackoffUntil) return;
    if (remoteAssets.has(blob)) return remoteAssets.get(blob).promise;
    const entry = { url: '', promise: null };
    root.dataset.assetUploadsPending = String(Number(root.dataset.assetUploadsPending || 0) + 1);
    entry.promise = new Promise(resolve => {
      assetQueue.push(async () => {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 20000);
        try {
          const id = crypto.randomUUID().replaceAll('-', '');
          const response = await fetch('/apps/droplit-nfc/cart-upload?asset=' + id, {
            method: 'POST', body: blob, headers: { 'Content-Type': blob.type }, signal: controller.signal
          });
          if (!response.ok) throw new Error('Background save unavailable');
          const payload = await response.json();
          const url = new URL(payload.url);
          if (url.origin !== assetOrigin || !/^\/customer-artwork\/[a-f0-9]{32}\/(png|jpg|webp)$/.test(url.pathname) || url.search || url.hash || url.username || url.password) throw new Error('Unexpected artwork address');
          entry.url = url.href;
          root.dataset.assetUploadsReady = String(Number(root.dataset.assetUploadsReady || 0) + 1);
        } catch (_) {
          assetBackoffUntil = Date.now() + 30000;
          root.dataset.assetUploadFallback = '1';
        } finally {
          clearTimeout(timer);
          root.dataset.assetUploadsPending = String(Math.max(0, Number(root.dataset.assetUploadsPending || 1) - 1));
          resolve(entry.url);
        }
      });
      pumpAssetQueue();
    });
    remoteAssets.set(blob, entry);
    return entry.promise;
  }
  function warmDropAssets(root, drop, number) {
    compactArtwork(drop).then(blob => backgroundAsset(root, blob)).catch(() => {});
    placementProof(root, drop, number).then(blob => backgroundAsset(root, blob)).catch(() => {});
  }
  function readyAsset(blob) { return blob instanceof Blob ? remoteAssets.get(blob)?.url || '' : ''; }

  function uploadBundle(formData, button) {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      const started = performance.now();
      let transferredAt = started;
      const bytes = [...formData.values()].reduce((sum, value) => sum + (value instanceof Blob ? value.size : 0), 0);
      request.open('POST', '/cart/add.js');
      request.setRequestHeader('Accept', 'application/json');
      const label = button?.textContent || '';
      request.upload.onprogress = event => {
        if (button && event.lengthComputable) button.textContent = label + ' ' + Math.min(99, Math.round(event.loaded / event.total * 100)) + '%';
      };
      request.upload.onload = () => { transferredAt = performance.now(); if (button) button.textContent = label; };
      request.onload = () => {
        const metrics = { fileBytes: bytes, uploadMs: Math.round(transferredAt - started), responseMs: Math.round(performance.now() - transferredAt), totalMs: Math.round(performance.now() - started), status: request.status };
        if (button) button.dataset.cartTiming = JSON.stringify(metrics);
        resolve({ ok: request.status >= 200 && request.status < 300, json: async () => JSON.parse(request.responseText) });
      };
      request.onerror = request.onabort = () => reject(new Error('Connection interrupted. Check your cart before trying again.'));
      request.send(formData);
    });
  }

  const proofCache = new WeakMap();
  function placementProof(root, drop, number) {
    if (!root.hasAttribute('data-pet-builder')) return makePlacementProof(root, drop, number);
    const signature = [currentKey(root), number, drop.preview, drop.production, drop.originalPreview, drop.file, drop.printFile, drop.mikeDesignId, drop.scale, drop.positionX, drop.positionY, drop.cornerRadius, drop.frame];
    const cached = proofCache.get(drop);
    if (cached && signature.every((value, index) => Object.is(value, cached.signature[index]))) return cached.promise;
    const entry = { signature, promise: makePlacementProof(root, drop, number) };
    proofCache.set(drop, entry);
    entry.promise.catch(() => { if (proofCache.get(drop) === entry) proofCache.delete(drop); });
    return entry.promise;
  }

  async function ensureExports(root, indexes) {
    const slots = isPetsB(root) ? (root.__dlSlots || []).slice(0,1) : (root.__dlSlots || []);
    await Promise.all(indexes.map(async index => {
      const drop = slots[index];
      if (!drop) return;
      drop.proofHat = HATS[currentKey(root)].label;
      try {
        drop.proofFile = await placementProof(root, drop, index + 1);
      } catch (error) {
        drop.proofFile = null;
        console.info(`[DropLit placement proof] Drop ${index + 1} will use the email-rendered preview.`, error);
      }
    }));
  }

  function addDrop(formData, number, drop) {
    if(drop?.mikeDesignId){drop={...drop,preview:drop.originalPreview,production:drop.originalPreview,file:null,printFile:null,scale:1,positionX:0,positionY:0,cornerRadius:0,cropped:false,bgRemoved:false,backgroundRemoved:false};formData.append('properties[_Drop '+number+' Library ID]',drop.mikeDesignId);formData.append('properties[_Drop '+number+' Artwork Version]',drop.libraryArtworkVersion||'');}

    if (drop?.mikeDesignId) {
      formData.append(`properties[_Drop ${number} Artist ID]`, 'mike-mcintire');
      formData.append(`properties[_Drop ${number} Artist]`, 'Mike McIntire');
    } else if (drop?.libraryDesignId) {
      formData.append(`properties[_Drop ${number} Library ID]`, drop.libraryDesignId);
      formData.append(`properties[_Drop ${number} Artwork Version]`, drop.libraryArtworkVersion || '');
    }
    const artworkKey = `properties[_Drop ${number} Artwork]`;
    const artwork = drop?.printFile instanceof Blob ? drop.printFile : drop?.file instanceof Blob ? drop.file : null;
    const savedArtwork = readyAsset(artwork);
    if (savedArtwork) formData.append(artworkKey, savedArtwork);
    else if (artwork) formData.append(artworkKey, artwork, artwork.name || `droplit-drop-${number}-print.png`);
    else {
      const url = artworkValue(drop);
      if (url) formData.append(artworkKey, url);
    }
    if (drop?.proofFile instanceof Blob) {
      const savedProof = readyAsset(drop.proofFile);
      if (savedProof) formData.append(`properties[_Drop ${number} Placement Proof]`, savedProof);
      else formData.append(`properties[_Drop ${number} Placement Proof]`, drop.proofFile, drop.proofFile.name || `droplit-drop-${number}-placement-proof.png`);
    }
    formData.append(`properties[_Drop ${number} Name]`, cleanDropName(drop, number));
    formData.append(`properties[Drop ${number}]`, (drop?.source || 'custom') === 'custom' && !drop?.libraryDesignId && !drop?.mikeDesignId ? 'Custom uploaded design' : cleanDropName(drop, number));
    formData.append(`properties[_Drop ${number} Source]`, drop?.source || 'custom');
    formData.append(`properties[_Drop ${number} Scale]`, `${Math.round((Number(drop?.scale) || 1) * 100)}%`);
    formData.append(`properties[_Drop ${number} Left Right]`, String(Number(drop?.positionX) || 0));
    formData.append(`properties[_Drop ${number} Up Down]`, String(Number(drop?.positionY) || 0));
    if (drop?.proofHat) formData.append(`properties[_Drop ${number} Hat]`, String(drop.proofHat));
    if (drop?.printPixelSize) formData.append(`properties[_Drop ${number} Print Pixels]`, String(drop.printPixelSize));
    if (drop?.backgroundRemoved || drop?.bgRemoved) formData.append(`properties[_Drop ${number} Background Removed]`, 'Yes');
    if (drop?.frame) formData.append(`properties[_Drop ${number} Frame]`, drop.frame);
    if (drop?.cropped) formData.append(`properties[_Drop ${number} Cropped]`, 'Yes');
    if (Number(drop?.cornerRadius) > 0) formData.append(`properties[_Drop ${number} Corner Radius]`, `${drop.cornerRadius}%`);
  }

  function clearPermissionHighlight(root) {
    const area = root.querySelector('[data-permission-area]') || root.querySelector('[data-rights]')?.closest('.rights');
    area?.classList.remove('dl-permission-attention');
  }

  function highlightPermission(root, rights) {
    const area = rights?.closest('.rights') || rights;
    if (!area) return;
    area.setAttribute('data-permission-area', '');
    area.classList.add('dl-permission-attention');
    setTimeout(() => area.scrollIntoView({ behavior: 'smooth', block: 'center' }), 30);
  }

  async function add(root) {
    if (isPetsB(root) && root.dataset.petsLastBundle) { await root.__dlOpenCartDrawer?.(); return; }
    if (isPetsB(root) && root.dataset.offerDraft === 'true') return tell(root, 'This preview offer is not available for purchase yet.');
    window.DroplitFunnel?.track('add_to_cart_clicked');
    const slots = isPetsB(root) ? (root.__dlSlots || []).slice(0,1) : (root.__dlSlots || []);
    const button = root.querySelector('[data-add]');
    const rights = root.querySelector('[data-rights]');
    if (!requiredSaved(root)) {
      window.DroplitFunnel?.track('add_to_cart_blocked', { reason: 'required_drops' });
      return prerequisiteNotice(root, false);
    }
    const needsRights=slots.some(d=>d&&!d.libraryDesignId&&!d.mikeDesignId);
    if (needsRights && !rights?.checked) {
      window.DroplitFunnel?.track('add_to_cart_blocked', { reason: 'image_permission' });
      return prerequisiteNotice(root, true);
    }
    clearPermissionHighlight(root);
    let meta = hatsFor(root)[currentKey(root)];
    const mikePage = document.querySelector('[data-mike-page]');
    const commerce = root.__dlMikeCommerce;
    const quote = commerce?.quote();
    if (mikePage && (!commerce?.enabled || !quote?.ready)) return tell(root, commerce?.unavailable || 'Purchasing is not available yet.');
    if (mikePage) meta = { ...meta, id: String(quote.bundle.id) };
    if (!meta) return tell(root, 'Please choose a hat before adding your bundle.');
    if (root.dataset.cartBusy === '1') return;
    if (slots.some((drop, index) => drop && root.dataset[`dlSaved${index + 1}`] !== '1')) { window.DroplitFunnel?.track('add_to_cart_blocked', { reason: 'unsaved_extra' }); return tell(root, 'Please save each Drop before adding your bundle.'); }

    root.dataset.cartBusy = '1';
    const oldHtml = button?.innerHTML;
    if (button) {
      button.dataset.busy = '1';
      button.disabled = true;
      button.innerHTML = '<span>PREPARING PRINT FILES…</span>';
    }

    try {
      const selected = [0, 1, 2, 3].filter(index => slots[index]);
      const uploadSlots = slots.slice();
      await Promise.all([ensureExports(root, selected), ...selected.map(async index => {
        if (!root.hasAttribute('data-pet-builder')) return;
        const artwork = await compactArtwork(slots[index]);
        uploadSlots[index] = artwork ? { ...slots[index], printFile: artwork } : slots[index];
      })]);
      selected.forEach(index => { uploadSlots[index].proofFile = slots[index].proofFile; uploadSlots[index].proofHat = slots[index].proofHat; });
      const formData = new FormData();
      const bundleId = crypto.randomUUID();
      const itemForm = index => ({
        append(key, value, filename) {
          const match = key.match(/^properties\[(.*)\]$/);
          const target = match ? `items[${index}][properties][${match[1]}]` : `items[${index}][${key}]`;
          if (filename) formData.append(target, value, filename);
          else formData.append(target, value);
        }
      });
      const parent = itemForm(0);
      parent.append('id', meta.id);
      parent.append('quantity', '1');
      parent.append('properties[Hat Style]', meta.label);
      if(document.querySelector('[data-mike-page]')){parent.append('properties[Collaboration]','DropLit x Mike McIntire Art');parent.append('properties[_Campaign]','mike-mcintire');const source=new URLSearchParams(location.search).get('utm_source');if(source)parent.append('properties[_Referral Source]',source.slice(0,100));}
      parent.append('properties[_DropLit Bundle ID]', bundleId);
      if (isPetsB(root)) {
        // A new token per cart addition; quantity is validated against the paid order on redemption.
        const credit = Array.from(crypto.getRandomValues(new Uint8Array(32)), b=>b.toString(16).padStart(2,'0')).join('');
        parent.append('properties[_custom_drop_credit]',credit);
        parent.append('properties[_Campaign]','pets-b');
        parent.append('properties[Bonus]','1 custom emblem credit per hat — free shipping whenever redeemed');
      }
      parent.append('properties[_DropLit Analytics Environment]', document.getElementById('droplit-analytics-config')?.dataset.environment || 'testing');
      parent.append('properties[_DropLit Analytics Theme]', document.getElementById('droplit-analytics-config')?.dataset.themeId || '');
      parent.append('properties[_DropLit Purchase Type]', isPetsB(root) ? 'pets-b-bonus-bundle' : (mikePage ? 'mike-bundle' : 'custom-bundle'));
      addDrop(parent, 1, uploadSlots[0]);
      if (!isPetsB(root)) addDrop(parent, 2, uploadSlots[1]);
      selected.filter(index => index >= 2).forEach((index, childIndex) => {
        const child = itemForm(childIndex + 1);
        child.append('id', mikePage ? String(quote.extras.find(extra => extra.index === index).variant.id) : '49208683135161');
        child.append('quantity', '1');
        child.append('parent_id', meta.id);
        child.append('properties[_DropLit Bundle ID]', bundleId);
        child.append('properties[_DropLit Extra]', String(index + 1));
        child.append('properties[Design]', `Drop ${index + 1} · ${cleanDropName(slots[index], index + 1)}`);
        addDrop(child, index + 1, uploadSlots[index]);
      });
      if (button) button.innerHTML = '<span>ADDING YOUR BUNDLE…</span>';
      const response = await uploadBundle(formData, button);
      if (!response.ok) {
        let message = 'Could not add your bundle to cart. Please try again.';
        try {
          const payload = await response.json();
          if (payload?.description) message = payload.description;
        } catch (_) {}
        throw new Error(message);
      }
      if (isPetsB(root)) root.dataset.petsLastBundle = bundleId;
      window.DroplitFunnel?.track('add_to_cart_success');
      const allowedOffers = ['MIKE15', 'WELCOME15'];
      let welcomeOffer = (new URLSearchParams(location.search).get('discount') || '').trim().toUpperCase();
      try { if (!allowedOffers.includes(welcomeOffer)) welcomeOffer = sessionStorage.getItem('droplit:welcome:offer:v1') || ''; } catch (_) {}
      if (allowedOffers.includes(welcomeOffer)) {
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: welcomeOffer })
          });
        } catch (error) { console.warn('[DropLit welcome offer]', error); }
      }
      if (isPetsB(root) && typeof root.__dlOpenCartDrawer === 'function') {
        await root.__dlOpenCartDrawer();
        root.dataset.cartBusy = '0';
        if(button){button.dataset.busy='0';button.disabled=false;button.innerHTML=oldHtml;}
      } else {
      window.location.assign(allowedOffers.includes(welcomeOffer) ? '/cart?discount=' + encodeURIComponent(welcomeOffer) : '/cart');
      }
    } catch (error) {
      root.dataset.cartBusy = '0';
      window.DroplitFunnel?.track('add_to_cart_error', { reason: 'export_or_cart_request' });
      console.error('[DropLit cart flow]', error);
      tell(root, error?.message || 'Could not prepare your print files. Please tap Save Drop again and retry.');
      if (button) {
        button.dataset.busy = '0';
        button.disabled = false;
        button.innerHTML = oldHtml;
      }
    }
  }

  function wire(root) {
    if (root.dataset.dlCartFlowSafeV6) return;
    root.dataset.dlCartFlowSafeV6 = '1';
    root.__dlEnsureExports = indexes => ensureExports(root, indexes);
    if (isPetsB(root)) root.__dlPetsAdd = () => add(root);
    const clearPrerequisites = () => root.querySelectorAll('[data-dl-prerequisite-notice]').forEach(el => el.remove());
    root.addEventListener('change', event => { if (event.target.matches('[data-rights]')) clearPrerequisites(); });
    root.addEventListener('droplit:drop-saved', event => {
      if (root.hasAttribute('data-pet-builder')) {
        const index = Number(event.detail?.slot) - 1;
        if (Number.isInteger(index) && index >= 0 && index < 4) setTimeout(() => {
          const drop = root.__dlSlots?.[index];
          if (drop) {
            warmDropAssets(root, drop, index + 1);
          }
        }, 0);
      }
      if (requiredSaved(root)) clearPrerequisites();
    });
    const select = root.querySelector('[data-variants]');
    const rights = root.querySelector('[data-rights]');
    root.querySelectorAll('[data-hat-choice]').forEach(button => button.addEventListener('click', () => applyHat(root, button.dataset.hatChoice)));
    if (select) {
      select.removeAttribute('aria-hidden');
      select.removeAttribute('tabindex');
      select.disabled = false;
      select.addEventListener('change', () => {
        const key = byId[String(select.value)];
        if (key) applyHat(root, key, { updateSelect: false });
      });
    }
    if (rights) {
      const area = rights.closest('.rights') || rights;
      area.setAttribute('data-permission-area', '');
      rights.addEventListener('change', () => {
        if (rights.checked) clearPermissionHighlight(root);
      });
    }
    root.addEventListener('click', event => {
      const button = event.target.closest?.('[data-add],[data-add-bottom]');
      if (!button) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      add(root);
    }, true);
    const initial = select ? byId[String(select.value)] : null;
    applyHat(root, initial || currentKey(root));
  }

  function boot() {
    document.querySelectorAll('.dl').forEach(wire);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

